<template>
	<div class="agreement">
		<HeaderVertical :title="title"></HeaderVertical>
		<div v-html="content" class="content"></div>
	</div>
</template>

<script>
import {
    getConfigData,
} from '@/api/bgConfig';
const configId = process.env.NODE_ENV === 'production' ? 1 : 3
export default {
	data() {
		return {
			title: '',
			content: ''
		}
	},
	mounted() {
		getConfigData({ ids: [configId] }).then((data) => {
			const config = data[configId] || {}
			const config_value = JSON.parse(config.config_value)
			const { Agreement_Title, Agreement_Content } = config_value
			this.title = decodeURI(Agreement_Title)
			this.content = decodeURI(Agreement_Content)
		})
	}
};
</script>

<style lang="less" scoped>
@import './agreementH5.less';
</style>
